import { css } from '@emotion/react'
import {
  Box,
  Button,
  Checkbox,
  GRangeFilterPrice,
  HStack,
  Text,
} from '@gazin/ecommerce-ui'
import { FormEventHandler, useState } from 'react'
import {
  Filter,
  SelectedFilters,
  Value,
} from 'src/services/searchProducts/dtos'
import { getFilteredPrice, minimumAndMaximumPrice } from 'src/util/products'
import { FilterProduct as FiltersProductProps } from '../../templates/SearchAndCategory'
import { Accordion } from '../accordion'

export type RemoveFilter = {
  id_atributo: number | string
  label: string
}

type FilterProductProps = {
  filter: Filter
  keyFilter: number
  removeFilter: ({ id_atributo, label }: RemoveFilter) => void
  selectedFilters?: SelectedFilters[]
  selectFilter({
    attribute,
    id_atributo,
    id_valor_unidade,
    label,
    tipo,
    valor_maximo,
    valor_minimo,
    queryFiltro,
  }: FiltersProductProps): void
}

export default function FilterProduct({
  filter,
  keyFilter,
  removeFilter,
  selectedFilters,
  selectFilter,
}: FilterProductProps) {
  const [showMore, setShowMore] = useState(false)

  function resetScroll() {
    const filterScroll = document.querySelector(`.filter-scroll-${keyFilter}`)

    filterScroll?.scroll(0, 0)
  }

  const filteredPrice = getFilteredPrice(selectedFilters)
  const { min: priceMin, max: priceMax } = minimumAndMaximumPrice(filter.values)

  if (filter.attribute === 'Preço' && (!priceMin || !priceMax)) return null

  const handleClick = (item: Value) => {
    const facet = item?.idO
    if (!facet) return

    const itemToRemove = {
      id_atributo: facet,
      label: String(item?.label),
    }

    item.selected
      ? removeFilter(itemToRemove)
      : selectFilter({
          attribute: filter.attribute,
          id_atributo: facet,
          id_valor_unidade: String(item?.id ?? ''),
          label: item?.label ?? '',
          tipo: filter.type,
          valor_maximo: item?.max?.value,
          valor_minimo: item?.min?.value,
        })
  }

  return (
    <>
      <Box
        alignItems="flex-start"
        justifyContent="space-between"
        w="100%"
        h="100%"
        key={keyFilter}
      >
        <Accordion.Item title={filter?.attribute}>
          {filter?.attribute === 'Preço' ? (
            <Box w="95%" margin="0 auto">
              <GRangeFilterPrice
                minimumPrice={
                  filteredPrice?.min ||
                  minimumAndMaximumPrice(filter.values).min
                }
                maximumPrice={
                  filteredPrice?.max ||
                  minimumAndMaximumPrice(filter.values).max
                }
                onChange={
                  ((minimum, maximum) => {
                    filter?.attribute === 'Preço' &&
                      filter?.values?.map((item: any) => {
                        if (!item?.idO) return

                        return selectFilter({
                          id_atributo: item.idO,
                          // contínuo (preço): posição do unityId no contrato c:facet:unityId:min:max
                          id_valor_unidade: String(
                            item?.unityId ?? item?.id ?? ''
                          ),
                          tipo: filter.type,
                          valor_minimo: minimum,
                          valor_maximo: maximum,
                          attribute: filter.attribute,
                          label: item?.label ?? '',
                        })
                      })
                  }) as ((minimum: number, maximum: number) => void) &
                    FormEventHandler<HTMLDivElement>
                }
                css={css`
                  p {
                    display: none;
                  }
                `}
              />
            </Box>
          ) : (
            <>
              <Box
                maxH={{ base: '7.5rem', xl: '10rem', '2xl': '12rem' }}
                h="100%"
                overflow={`${showMore ? 'auto' : 'hidden'}`}
                css={css`
                  &::-webkit-scrollbar {
                    width: 0.375rem;
                  }

                  &::-webkit-scrollbar-thumb {
                    background-color: rgba(176, 179, 192, 0.5);
                    border-radius: 20px;
                  }
                `}
                className={`filter-scroll-${keyFilter}`}
              >
                {filter?.values?.map((item) => (
                  <HStack
                    alignItems="center"
                    justifyContent="space-between"
                    key={item.id}
                  >
                    <HStack>
                      <Checkbox
                        borderColor="neutral.200"
                        onChange={() => handleClick(item)}
                        isChecked={item?.selected}
                      />
                      <Text
                        color="neutral.600"
                        fontSize="0.875rem"
                        lineHeight="1.5rem"
                        fontFamily="body"
                      >
                        {item?.label}
                      </Text>
                    </HStack>
                  </HStack>
                ))}
              </Box>
              <Button
                variant="ghost"
                color="primary.500"
                fontSize="0.875rem"
                mt="1rem"
                fontWeight="600"
                lineHeight="1.05rem"
                _hover={{ bg: 'transparent' }}
                h="fit-content"
                px={0}
                alignItems="flex-start"
                justifyContent="flex-start"
                display={`${filter?.values?.length > 5 ? 'flex' : 'none'}`}
                onClick={() => {
                  resetScroll()
                  setShowMore(!showMore)
                }}
              >
                {showMore ? 'Ver menos' : 'Ver tudo'}
              </Button>
            </>
          )}
        </Accordion.Item>
      </Box>
    </>
  )
}
